export const styles = (theme) => ({
  right: {
    // position: 'absolute',
    // right: '0px',
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
  },
  flag: {
    border: "solid #fff 2px",
    borderRadius: "50%",
    // width: '1.5rem'
    height: "auto",
    width: "100%",
  },
  buttonItem: {
    backgroundColor: "#fff",
    // backgroundColor: '#0000000a',
    color: "#263238",
    fontSize: "0.8rem",
    textTransform: "capitalize",
    width: "143px",
  },
  buttonItemHeader: {
    backgroundColor: "#0000000a",
    color: "#ffffff",
    fontSize: "0.8rem",
    textTransform: "capitalize",
    width: "143px",
  },
  buttonLanguage: {
    margin: "16px 16px",
    padding: "0px",
    width: "143px",
  },
  menuItem: {
    fontSize: "0.8rem",
  },
  rootListItemIcon: {
    width: "28px",
    height: "28px",
    minWidth: "0",
    marginRight: "12px",
  },
});
